import React from "react";
import { Box, Container, Typography } from "@mui/material";
import { motion } from "framer-motion";

// Importing official icons
import iconIntegrity from "../../Assets/AboutusSection/Icons/Icon (1).svg";
import iconExcellence from "../../Assets/AboutusSection/Icons/Icon (2).svg";
import iconInnovation from "../../Assets/AboutusSection/Icons/Icon (3).svg";

const MIssionVisionSection = () => {
  const cards = [
    {
      title: "Integrity",
      description: "Transparency is the bedrock of our transactions. We build trust through honest communication and ethical stewardship of every project.",
      icon: iconIntegrity,
    },
    {
      title: "Excellence",
      description: "From the first sketch to the final coat of paint, we pursue a standard of quality that transcends market norms and sets new benchmarks.",
      icon: iconExcellence,
    },
    {
      title: "Innovation",
      description: "We leverage cutting-edge technology and sustainable practices to create homes that are not just contemporary, but future-ready.",
      icon: iconInnovation,
    },
  ];

  return (
    <Box
      sx={{
        width: "100%",
        backgroundColor: "#F6F3F2",
        py: { xs: "64px", md: "80px" }, // Slightly reduced vertical padding
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Container
        maxWidth={false}
        sx={{
          maxWidth: "1536px",
          width: { xs: "100%", lg: "1280px" },
          px: { xs: "24px", md: "48px" },
        }}
      >
        {/* Header Block */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1184px",
            mb: "48px", // Reduced bottom margin
            textAlign: "left",
          }}
        >
          <Typography
            sx={{
              fontFamily: "Inter, sans-serif",
              fontSize: "12px",
              fontWeight: 600,
              color: "#FF5722",
              textTransform: "uppercase",
              letterSpacing: "2.4px",
              mb: "12px",
            }}
          >
            THE ABILIO ETHOS
          </Typography>
          <Typography
            variant="h3"
            sx={{
              fontFamily: "Manrope, sans-serif",
              fontWeight: 700,
              fontSize: { xs: "28px", md: "36px" }, // Subtly decreased title size
              color: "#1C1B1B",
              lineHeight: "1.2",
              letterSpacing: "-1px"
            }}
          >
            Our Core Foundations
          </Typography>
        </Box>

        {/* Cards Grid - Decreased card size */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "1fr 1fr 1fr" },
            gap: "32px",
            width: "100%",
            maxWidth: "1184px",
          }}
        >
          {cards.map((card, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
            >
              <Box
                sx={{
                  // Decreased height to 280px for better vertical balance
                  height: "280px",
                  backgroundColor: "#FFFFFF",
                  borderRadius: "10px",
                  // Symmetric padding 48px to look "middle"
                  padding: { xs: "32px", md: "48px" },
                  boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)", 
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  textAlign: "left",
                  gap: "16px", // Exactly 16px as per specs
                  border: "1px solid rgba(0,0,0,0.02)",
                }}
              >
                <Box 
                  sx={{ 
                    mb: 1, 
                    display: "flex", 
                    alignItems: "center", 
                    justifyContent: "center",
                    width: "36px",
                    height: "36px"
                  }}
                >
                  <Box 
                    component="img" 
                    src={card.icon} 
                    alt={card.title}
                    sx={{ width: "100%", height: "100%", objectFit: "contain" }}
                  />
                </Box>
                <Typography
                  sx={{
                    fontFamily: "Manrope, sans-serif",
                    fontWeight: 700,
                    fontSize: "22px",
                    color: "#1C1B1B",
                  }}
                >
                  {card.title}
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Inter, sans-serif",
                    fontWeight: 300,
                    fontSize: "14.5px",
                    lineHeight: "24px",
                    color: "#5A413A",
                  }}
                >
                  {card.description}
                </Typography>
              </Box>
            </motion.div>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default MIssionVisionSection;
